import React, { useRef, useState } from "react";
import logo from "../assets/appnest_logo.png";
import ButtonCompo from "../component/ButtonCompo";
import loginVid from "../assets/login.mp4";
import PasswordField from "../component/PasswordField";
import InputField from "../component/InputField";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { superadminLogin } from "../store/superadminAuth.slice";
import AlertBox from "../component/AlertBox";
import { LinearProgress } from "@mui/material";
import axios from "axios";
import { SERVER_URL } from "../constant";
import DialogBox from "../component/DialogBox";
import { MdOutlineErrorOutline } from "react-icons/md";

function SuperadminSignIn() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const alertRef = useRef(null);

  const handleAlertOpen = () => {
    if (alertRef.current) {
      alertRef.current.handleOpen();
    }
  };

  async function signin() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/company/login`,
        method: "post",
        data: {
          email: username,
          password: password,
        },
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        //changing status in redux
        dispatch(superadminLogin({ status: true }));
        navigate("/superadmin/dashboard");
      }
    } catch (error) {
      if(error?.status === 403) {
        handleAlertOpen()
        return null
      }
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <DialogBox maxWidth="xs" ref={alertRef} closeActionButton="CLOSE">
          <p className="text-[20px] font-medium">Your Are Not Approved Yet</p>
          <div className="text-center w-full flex justify-center items-center mt-3">
            <MdOutlineErrorOutline className="text-red-600 text-[35px]" />
          </div>
          <p className="mt-3 text-slate-500">
            We have regret to inform you that your application is not approved yet. One of our team member will get back to you shortly. Thanks for your patience. 
          </p>
        </DialogBox>
      <div className="w-full flex items-center justify-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-1/2 hidden lg:flex h-[100vh]">
          <video
            src={loginVid}
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover"
          />
        </div>
        <div className="w-full lg:w-1/2 h-full flex flex-col justify-center items-center py-10">
          <img src={logo} className="w-[10rem] mb-[3rem]" alt="" />
          <div className="w-full flex justify-center items-center">
            <div className="w-[20rem] flex flex-col justify-center items-center">
              <div className="text-left w-full mb-5">
                <p className="text-[23px] font-semibold">Welcome Back</p>
                <span className="text-[15px] text-slate-500">
                  Please login to manage your company.
                </span>
              </div>
              <div className="w-full space-y-5">
                <InputField
                  label="Business Email ID"
                  onChange={(e) => setUsername(e?.target?.value)}
                />
                <PasswordField
                  onChange={(e) => setPassword(e?.target?.value)}
                />
              </div>
              <ButtonCompo
                variant="contained"
                className="!mt-5 w-full"
                onClick={signin}
              >
                login
              </ButtonCompo>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SuperadminSignIn;
